import { DataSource, NoteKind } from "../generated/graphql";
import { ProcedureRecord } from "../types/procedure";

type ProcedureNote = NonNullable<ProcedureRecord["procedureNotesList"][number]["procedureNotes"]>;

type ProcedureSync = ProcedureRecord["documentationSyncsList"][number];

/** The selected senior's finalized document, never a shared or draft note. */
export const getProcedureDocumentationNote = (procedure: ProcedureRecord, seniorId?: string): ProcedureNote | null => {
  if (!seniorId) return null;
  return (
    procedure.procedureNotesList?.find(
      ({ procedureNotes: note }) =>
        note?.kind === NoteKind.ActivityDocumentation &&
        note.publishedAt &&
        note.seniorList.length === 1 &&
        note.seniorList[0].id === seniorId
    )?.procedureNotes ?? null
  );
};

export const getProcedureDocumentation = (procedure: ProcedureRecord, seniorId?: string): string | null =>
  getProcedureDocumentationNote(procedure, seniorId)?.note ?? null;

/** M4C documents are exported as their own Bericht; provider Maßnahmen are exported with their sign-off. */
export const getProcedureDocumentationSyncs = (procedure: ProcedureRecord, seniorId?: string): ProcedureSync[] => {
  const note = getProcedureDocumentationNote(procedure, seniorId);
  if (!note) return [];
  return procedure.sourceSystem === DataSource.M4C ? note.documentationSyncsList : procedure.documentationSyncsList;
};
